import { render, staticRenderFns } from "./jgwy.vue?vue&type=template&id=757cc2f0&scoped=true"
import script from "./jgwy.vue?vue&type=script&lang=js"
export * from "./jgwy.vue?vue&type=script&lang=js"
import style0 from "./jgwy.vue?vue&type=style&index=0&id=757cc2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757cc2f0",
  null
  
)

export default component.exports